export const CPHLightFestivalStyle = 
[
  {
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#212121"
  }
  ]
  },
  {
  "elementType": "labels.text",
  "stylers": [
  {
  "color": "#ffffff"
  },
  {
  "visibility": "simplified"
  }
  ]
  },
  {
  "featureType": "administrative",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#757575"
  }
  ]
  },
  {
  "featureType": "administrative",
  "elementType": "labels.text",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "administrative.land_parcel",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "landscape",
  "elementType": "labels.text",
  "stylers": [
  {
  "color": "#ffffff"
  },
  {
  "visibility": "simplified"
  }
  ]
  },
  {
  "featureType": "landscape.man_made",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#c0c0c0"
  }
  ]
  },
  {
  "featureType": "landscape.natural",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#43c4be"
  },
  {
  "saturation": -80
  },
  {
  "lightness": 10
  }
  ]
  },
  {
  "featureType": "landscape.natural",
  "elementType": "geometry.fill",
  "stylers": [
  {
  "color": "#669c35"
  }
  ]
  },
  {
  "featureType": "landscape.natural.landcover",
  "elementType": "geometry",
  "stylers": [
  {
  "visibility": "simplified"
  }
  ]
  },
  {
  "featureType": "landscape.natural.terrain",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi",
  "stylers": [
  {
  "visibility": "simplified"
  }
  ]
  },
  {
  "featureType": "poi",
  "elementType": "labels.text",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi",
  "elementType": "labels.text.fill",
  "stylers": [
  {
  "color": "#757575"
  }
  ]
  },
  {
  "featureType": "poi.business",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi.medical",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi.park",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#4f7a28"
  }
  ]
  },
  {
  "featureType": "poi.place_of_worship",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi.school",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "poi.sports_complex",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "road",
  "stylers": [
  {
  "color": "#7a7a7a"
  }
  ]
  },
  {
  "featureType": "road",
  "elementType": "geometry.fill",
  "stylers": [
  {
  "color": "#2c2c2c"
  }
  ]
  },
  {
  "featureType": "road",
  "elementType": "labels.text",
  "stylers": [
  {
  "color": "#ffffff"
  }
  ]
  },
  {
  "featureType": "road.arterial",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#373737"
  }
  ]
  },
  {
  "featureType": "road.highway",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#3c3c3c"
  }
  ]
  },
  {
  "featureType": "road.highway",
  "elementType": "geometry.fill",
  "stylers": [
  {
  "saturation": -20
  }
  ]
  },
  {
  "featureType": "road.highway",
  "elementType": "labels.text",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "road.highway.controlled_access",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#4e4e4e"
  }
  ]
  },
  {
  "featureType": "transit",
  "stylers": [
  {
  "color": "#2f3b8e"
  }
  ]
  },
  {
  "featureType": "transit",
  "elementType": "labels.text",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "transit",
  "elementType": "labels.text.fill",
  "stylers": [
  {
  "color": "#ffffff"
  },
  {
  "visibility": "simplified"
  }
  ]
  },
  {
  "featureType": "transit.line",
  "stylers": [
  {
  "visibility": "off"
  }
  ]
  },
  {
  "featureType": "transit.station",
  "elementType": "geometry.fill",
  "stylers": [
  {
  "color": "#ffffff"
  }
  ]
  },
  {
  "featureType": "transit.station.airport",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#669c35"
  },
  {
  "saturation": 15
  },
  {
  "lightness": -15
  }
  ]
  },
  {
  "featureType": "water",
  "elementType": "geometry",
  "stylers": [
  {
  "color": "#000000"
  }
  ]
  },
  {
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [
  {
  "color": "#518ebd"
  },
  {
  "saturation": -25
  },
  {
  "lightness": -30
  }
  ]
  }
 ]
// [
//   {
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#1d2c4d"
//       }
//     ]
//   },
//   {
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#8ec3b9"
//       }
//     ]
//   },
//   {
//     "elementType": "labels.text.stroke",
//     "stylers": [
//       {
//         "color": "#1a3646"
//       }
//     ]
//   },
//   {
//     "featureType": "administrative",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "administrative.country",
//     "elementType": "geometry.stroke",
//     "stylers": [
//       {
//         "color": "#4b6878"
//       }
//     ]
//   },
//   {
//     "featureType": "administrative.land_parcel",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#64779e"
//       }
//     ]
//   },
//   {
//     "featureType": "administrative.province",
//     "elementType": "geometry.stroke",
//     "stylers": [
//       {
//         "color": "#4b6878"
//       }
//     ]
//   },
//   {
//     "featureType": "landscape.man_made",
//     "elementType": "geometry.stroke",
//     "stylers": [
//       {
//         "color": "#334e87"
//       }
//     ]
//   },
//   {
//     "featureType": "landscape.natural",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#023e58"
//       }
//     ]
//   },
//   {
//     "featureType": "poi",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "poi",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#283d6a"
//       }
//     ]
//   },
//   {
//     "featureType": "poi",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#6f9ba5"
//       }
//     ]
//   },
//   {
//     "featureType": "poi",
//     "elementType": "labels.text.stroke",
//     "stylers": [
//       {
//         "color": "#1d2c4d"
//       }
//     ]
//   },
//   {
//     "featureType": "poi.park",
//     "elementType": "geometry.fill",
//     "stylers": [
//       {
//         "color": "#023e58"
//       }
//     ]
//   },
//   {
//     "featureType": "poi.park",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#3C7680"
//       }
//     ]
//   },
//   {
//     "featureType": "road",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#304a7d"
//       }
//     ]
//   },
//   {
//     "featureType": "road",
//     "elementType": "labels.icon",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "road",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#98a5be"
//       }
//     ]
//   },
//   {
//     "featureType": "road",
//     "elementType": "labels.text.stroke",
//     "stylers": [
//       {
//         "color": "#1d2c4d"
//       }
//     ]
//   },
//   {
//     "featureType": "road.highway",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#2c6675"
//       }
//     ]
//   },
//   {
//     "featureType": "road.highway",
//     "elementType": "geometry.stroke",
//     "stylers": [
//       {
//         "color": "#255763"
//       }
//     ]
//   },
//   {
//     "featureType": "road.highway",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#b0d5ce"
//       }
//     ]
//   },
//   {
//     "featureType": "road.highway",
//     "elementType": "labels.text.stroke",
//     "stylers": [
//       {
//         "color": "#023e58"
//       }
//     ]
//   },
//   {
//     "featureType": "transit",
//     "stylers": [
//       {
//         "visibility": "off"
//       }
//     ]
//   },
//   {
//     "featureType": "transit",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#98a5be"
//       }
//     ]
//   },
//   {
//     "featureType": "transit",
//     "elementType": "labels.text.stroke",
//     "stylers": [
//       {
//         "color": "#1d2c4d"
//       }
//     ]
//   },
//   {
//     "featureType": "transit.line",
//     "elementType": "geometry.fill",
//     "stylers": [
//       {
//         "color": "#283d6a"
//       }
//     ]
//   },
//   {
//     "featureType": "transit.station",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#3a4762"
//       }
//     ]
//   },
//   {
//     "featureType": "water",
//     "elementType": "geometry",
//     "stylers": [
//       {
//         "color": "#0e1626"
//       }
//     ]
//   },
//   {
//     "featureType": "water",
//     "elementType": "labels.text.fill",
//     "stylers": [
//       {
//         "color": "#4e6d70"
//       }
//     ]
//   }
// ]